import { useState, useEffect, useCallback } from "react";

import Footer from "../../components/shared/Footer";
import AttachExhibits from "./components/AttachExhibits";
import AttorneySelect from "../../components/shared/AttorneySelect";
import ExistingEfileSummary from "./components/ExistingEFileSummary";
import * as APIModels from "../../models";

import { useParams } from "react-router-dom";
import {
    SubmissionService,
    eFileService,
} from "../../services/SubmissionService";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../components/shared/modals/ErrorModal";
import { Spinner } from "react-bootstrap";
import { PlayCircleFilled } from "@material-ui/icons";
import EmergencyFileModal from "./modals/EmergencyFileModal";
import NoEserviceModal from "./modals/NoEserviceModal";

export default function ExistingCase() {
    const { id } = useParams<{ id: string }>();

    const [eFileUpload, seteFileUpload] = useState(
        null as APIModels.eFile | null
    );
    const [addExhibit, setAddExhibits] = useState(null as null | boolean);
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState(0);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [emergencyFiling, setEmergencyFiling] = useState(false);
    const [showEmergencyFilingModal, setShowEmergencyFilingModal] =
        useState(false);
    const [showNoEserve, setShowNoEserve] = useState(false);
    const [noEserve, setNoEserve] = useState(false);

    useEffect(() => {
        console.log("eFileService.get start " + id);
        eFileService.get({ id: id }).then(
            (resp) => {
                setLoading(false);
                if (resp.successful && resp.data) {
                    console.log("eFileService.get success ");
                    //show efile success
                    if (eFileUpload === null) {
                        seteFileUpload(resp.data);
                    } else {
                        seteFileUpload({
                            ...resp.data,
                            attorneyID: eFileUpload.attorneyID,
                            attorneyName: eFileUpload.attorneyName,
                        });
                    }
                } else {
                    setErrorProps({
                        ...errorProps,
                        errorMessage: resp.errorMessage ?? "error",
                    });
                }
            },
            (error) => {
                setLoading(false);
                console.log(error);
            }
        );
    }, []);

    const [showErrorModal, setShowErrorModal] = useState(false);

    const onEMClose = () => {
        setErrorProps({ errorMessage: "", onClose: onEMClose });
        setShowErrorModal(false);
    };

    const [errorProps, setErrorProps] = useState({
        errorMessage: "",
        onClose: onEMClose,
    } as ErrorModalProps);

    // f4 to submit
    useEffect(() => {
        const handelKeyboardSubmit = (e: KeyboardEvent) => {
            if (e.key === "F4") {
                onSubmit();
            }
        };

        window.addEventListener("keydown", handelKeyboardSubmit);
        return window.removeEventListener("keydown", handelKeyboardSubmit);
    }, []);

    useEffect(() => {
        if (errorProps.errorMessage !== "") {
            console.log("show error modal:" + errorProps.errorMessage);
            setShowErrorModal(true);
        } else {
            setShowErrorModal(false);
        }
    }, [errorProps.errorMessage]);

    useEffect(() => {
        if (eFileUpload) {
            eval(
                "$('#checkout-nav-pills-wizard').bootstrapWizard({tabClass: 'nav nav-pills nav-justified'});"
            );
        }
    }, [eFileUpload]);

    useEffect(() => {
        console.log("Emerge " + emergencyFiling);
    }, [emergencyFiling, noEserve]);

    const onAttorneySelected = (id: string, name: string) => {
        if (eFileUpload === null) {
            seteFileUpload({ attorneyID: id, attorneyName: name });
        } else {
            seteFileUpload({
                ...eFileUpload,
                attorneyID: id,
                attorneyName: name,
            });
        }
    };
    const onFirmSelected = (id: string, name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: "", attorneyName: "" });
    };

    const onFinishedExhibits = (exhibits: APIModels.Exhibits) => {
        seteFileUpload({ ...eFileUpload, exhibits: exhibits });
    };

    const onClickAddExhibits = () => {
        setAddExhibits(true);
    };
    const onClickNoExhibits = () => {
        setAddExhibits(false);
    };

    const onSubmit = () => {
        if (emergencyFiling && !showEmergencyFilingModal) {
            setShowEmergencyFilingModal(true);
        } else {
            setShowEmergencyFilingModal(false);
            setShowNoEserve(false);
            setSubmitLoading(true);
            SubmissionService.uploadExisting({
                id: id,
                body: eFileUpload!,
            })
                .then(
                    (resp) => {
                        console.log(resp);
                        if (resp.successful && resp.data) {
                            //show efile success
                            window.location.href = "/uploads";
                        } else {
                            setErrorProps({
                                ...errorProps,
                                errorMessage: resp.errorMessage ?? "",
                            });
                        }
                    },
                    (error) => {
                        setErrorProps({
                            ...errorProps,
                            errorMessage: error.message,
                        });
                    }
                )
                .then(() => setSubmitLoading(false));
        }
    };

    const onComfirmEmergency = () => {
        onSubmit();
    };

    const onCancelEmergency = () => {
        setShowEmergencyFilingModal(false);
    };

    const onComfirmNoEservice = () => {
        onSubmit();
    };

    const onCancelNoEservice = () => {
        setShowEmergencyFilingModal(false);
        seteFileUpload((prev) => {
            return {
                noEserve: true,
                ...prev,
            };
        });
    };

    const onButtonClick = (button: number) => {
        console.log("Button Click " + button);
    };
    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Existing Case
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {eFileUpload !== null ? (
                    <div className="row">
                        {showErrorModal === true && (
                            <ErrorModal {...errorProps} />
                        )}
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-8">
                                            <div
                                                id="checkout-nav-pills-wizard"
                                                className="twitter-bs-wizard form-wizard-header"
                                            >
                                                <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                    <li className="nav-item">
                                                        <a
                                                            href="#attorney-info"
                                                            className="nav-link active"
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                        >
                                                            <span className="number">
                                                                1
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Attorney
                                                            </span>
                                                        </a>
                                                    </li>
                                                    {eFileUpload?.filenames
                                                        ?.length === 1 && (
                                                        <li className="nav-item">
                                                            <a
                                                                href="#exhibit-info"
                                                                className="nav-link"
                                                                data-bs-toggle="tab"
                                                                data-toggle="tab"
                                                                style={{
                                                                    pointerEvents:
                                                                        "none",
                                                                }}
                                                            >
                                                                <span className="number">
                                                                    2
                                                                </span>
                                                                <span className="d-none d-sm-inline">
                                                                    Exhibits
                                                                    (Optional)
                                                                </span>
                                                            </a>
                                                        </li>
                                                    )}
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            href="#summary"
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                        >
                                                            <span className="number">
                                                                {eFileUpload
                                                                    ?.filenames
                                                                    ?.length ===
                                                                1
                                                                    ? 3
                                                                    : 2}
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Summary
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div className="tab-content twitter-bs-wizard-tab-content">
                                                    <div
                                                        className="tab-pane active"
                                                        id="attorney-info"
                                                    >
                                                        <div>
                                                            <h4 className="header-title">
                                                                Attorney
                                                                Information
                                                            </h4>
                                                            <p className="sub-header">
                                                                Please select
                                                                the attorney
                                                                filing the
                                                                pleadings.
                                                            </p>
                                                            {!loading && (
                                                                <ul>
                                                                    {eFileUpload?.filenames?.map(
                                                                        (v) => (
                                                                            <li>
                                                                                {
                                                                                    v
                                                                                }
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            )}
                                                        </div>
                                                        <AttorneySelect
                                                            onAttorneySelected={
                                                                onAttorneySelected
                                                            }
                                                            onFirmSelected={
                                                                onFirmSelected
                                                            }
                                                        />
                                                        <ul className="pager wizard list-inline mt-2">
                                                            <li className="list-inline-item">
                                                                <a
                                                                    href="/uploads"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left"></i>{" "}
                                                                    Back to
                                                                    Upload
                                                                </a>
                                                            </li>

                                                            {!eFileUpload?.attorneyID ||
                                                            eFileUpload?.attorneyID ==
                                                                "" ? (
                                                                <li
                                                                    className="next list-inline-item float-end"
                                                                    style={{
                                                                        pointerEvents:
                                                                            "none",
                                                                    }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success disabled"
                                                                        disabled={
                                                                            true
                                                                        }
                                                                    >
                                                                        Next
                                                                        <i className="mdi mdi-arrow-right"></i>{" "}
                                                                    </button>
                                                                </li>
                                                            ) : (
                                                                <li className="next list-inline-item float-end">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Next
                                                                        <i className="mdi mdi-arrow-right"></i>{" "}
                                                                    </button>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                    {eFileUpload?.filenames
                                                        ?.length === 1 && (
                                                        <div
                                                            className="tab-pane"
                                                            id="exhibit-info"
                                                        >
                                                            <div>
                                                                <h4 className="header-title">
                                                                    Exhibit
                                                                </h4>

                                                                <p className="sub-header">
                                                                    Do you need
                                                                    to attach
                                                                    additional
                                                                    exhibits to
                                                                    your filing?
                                                                </p>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        onClick={
                                                                            onClickAddExhibits
                                                                        }
                                                                    >
                                                                        Yes
                                                                    </button>
                                                                    &nbsp;
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        onClick={
                                                                            onClickNoExhibits
                                                                        }
                                                                    >
                                                                        No
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    {addExhibit && (
                                                                        <AttachExhibits
                                                                            callback={
                                                                                onFinishedExhibits
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                                <div />
                                                            </div>
                                                            <ul className="pager wizard list-inline mt-2">
                                                                <li className="previous list-inline-item">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary"
                                                                    >
                                                                        <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                        Back to
                                                                        Attorney
                                                                    </button>
                                                                </li>
                                                                {addExhibit ===
                                                                    false ||
                                                                (addExhibit ==
                                                                    true &&
                                                                    eFileUpload?.exhibits !=
                                                                        undefined &&
                                                                    eFileUpload
                                                                        ?.exhibits
                                                                        .filenames!
                                                                        .length !=
                                                                        0) ? (
                                                                    <li className="next list-inline-item float-end">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success"
                                                                        >
                                                                            Next
                                                                            <i className="mdi mdi-arrow-right"></i>{" "}
                                                                        </button>
                                                                    </li>
                                                                ) : (
                                                                    <li
                                                                        className="next list-inline-item float-end"
                                                                        style={{
                                                                            pointerEvents:
                                                                                "none",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success disabled"
                                                                            disabled={
                                                                                true
                                                                            }
                                                                        >
                                                                            Next
                                                                            <i className="mdi mdi-arrow-right"></i>{" "}
                                                                        </button>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    )}
                                                    <div
                                                        className="tab-pane"
                                                        id="summary"
                                                    >
                                                        <div>
                                                            <h4 className="header-title">
                                                                Summary
                                                            </h4>
                                                            <p className="sub-header">
                                                                Review the
                                                                information
                                                                below and verify
                                                                for accuracy.
                                                            </p>
                                                        </div>
                                                        <div>
                                                            {" "}
                                                            <ExistingEfileSummary
                                                                upload={
                                                                    eFileUpload ??
                                                                    {}
                                                                }
                                                                setUpload={
                                                                    seteFileUpload
                                                                }
                                                            />
                                                        </div>
                                                        <ul className="pager wizard list-inline mt-2">
                                                            <li className="previous list-inline-item">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                    Back
                                                                </button>
                                                            </li>

                                                            <li className="next list-inline-item float-end">
                                                                <button
                                                                    onClick={() =>
                                                                        onSubmit()
                                                                    }
                                                                    className="btn btn-success"
                                                                >
                                                                    {submitLoading && (
                                                                        <>
                                                                            <Spinner
                                                                                as="span"
                                                                                animation="border"
                                                                                size="sm"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            />
                                                                            &nbsp;
                                                                            Loading...
                                                                        </>
                                                                    )}
                                                                    {!submitLoading && (
                                                                        <>
                                                                            <PlayCircleFilled />{" "}
                                                                            Submit
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                        <div
                                                            className="form-check"
                                                            style={{
                                                                position:
                                                                    "relative",
                                                                top: "50%",
                                                                left: "90%",
                                                            }}
                                                        >
                                                            <EmergencyFileModal
                                                                show={
                                                                    showEmergencyFilingModal
                                                                }
                                                                onCancelEmergency={
                                                                    onCancelEmergency
                                                                }
                                                                onConfirmEmergency={
                                                                    onComfirmEmergency
                                                                }
                                                            ></EmergencyFileModal>
                                                            <input
                                                                className="form-check-input"
                                                                id="ckEmergency"
                                                                type="checkbox"
                                                                checked={
                                                                    emergencyFiling
                                                                }
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    setEmergencyFiling(
                                                                        event
                                                                            .currentTarget
                                                                            .checked
                                                                    );
                                                                    seteFileUpload(
                                                                        {
                                                                            ...eFileUpload,
                                                                            emergency:
                                                                                event
                                                                                    .currentTarget
                                                                                    .checked,
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="ckOverride"
                                                            >
                                                                Is this an
                                                                Emergency
                                                                Filing?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            height: "400px",
                            textAlign: "center",
                            paddingTop: "180px",
                        }}
                    >
                        <span
                            className="spinner-border spinner-border-lg me-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
}
